export const mixinmember = {
    data() {
        return {
            res: {},
            curnavkv: 0,
            navsub: 0,
            infolist: [],
            infodata: {},
            options: {},//筛选项
            isload: false,
            isnorecord: false
        };
    },
    components: {
        Cmembernav: () => import('@/components/Cmembernav'),
    }
}
